module.exports = __webpack_public_path__ + "static/media/logo_landing@2x.1657e2bb.jpg";